import { render, staticRenderFns } from "./AccountNotVerified.vue?vue&type=template&id=01dee68a"
import script from "./AccountNotVerified.vue?vue&type=script&lang=js"
export * from "./AccountNotVerified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports